export enum TeArtefactLocationEnum {

   before,
   after,
   inline,
}